<template>
    <div class="main-wrapper">
        <el-scrollbar class="table">
            <el-table :data="goodsTextList" class="customTable goods-text-table" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
                <el-table-column prop="content" label="考试内容" width="200px"></el-table-column>
                <el-table-column label="提交答案（点击商品查看详情）" align="left" width="380px">
                    <template slot-scope="scope">
                        <router-link class="answer" :to="{path: '/goods/detail', query: { }}" target="_blank">
                            <img :src="scope.row.img" alt="">
                            <span class="text">{{scope.row.name}}</span>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="search_num" label="搜索人数" align="center"></el-table-column>
                <el-table-column prop="click_rate" label="点击率" align="center"></el-table-column>
                <el-table-column prop="stu_click_num" label="学生点击量" align="center"></el-table-column>
                <el-table-column prop="full_click_num" label="满分点击量" align="center"></el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center" width="150px"></el-table-column>
            </el-table>
            <el-table :data="goodsShootList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="109px">
                <el-table-column prop="content" label="考试内容"></el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="viewGoodsImg(scope.row)" class="view-detail">查看详情</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center"></el-table-column>
                <el-table-column prop="score" label="操作" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="scoreDetailGoods(scope.row)" class="view-detail">评分详情</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-table :data="goodsVideoShootList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="109px">
                <el-table-column prop="content" label="考试内容"></el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="downloadFile(scope.row)" class="view-detail">下载文件</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分（15分）" align="center"></el-table-column>
                <el-table-column prop="score" label="操作" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="scoreDetailView(scope.row)" class="view-detail">评分详情</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>
        <el-dialog title="商品主图" :visible.sync="goodsImgDialog" width="764px" @close="handleCloseGoodsImgDialog" custom-class="green-dialog goods-img-dialog">
            <div class="upload-file-content">
                <div class="big-img">
                    <img src="../../../../assets/images/user_img.png" alt="">
                </div>
                <div class="small-img">
                    <img src="../../../../assets/images/user_img.png" alt="" @click="viewBigImg">
                    <img src="../../../../assets/images/user_img.png" alt="">
                    <img src="../../../../assets/images/user_img.png" alt="">
                    <img src="../../../../assets/images/user_img.png" alt="">
                    <img src="../../../../assets/images/user_img.png" alt="">
                    <img src="../../../../assets/images/user_img.png" alt="">
                    <img src="../../../../assets/images/user_img.png" alt="">
                </div>
            </div>
        </el-dialog>
        <el-dialog title="评分详情（选择评分评委同时对学生进行评分，去掉最高分和最低分，剩下分数的平均分作为该学生成绩）"
                   :visible.sync="scoreDetailDialog" width="830px" @close="handleCloseScoreDetailDialog" custom-class="green-dialog goods-score-dialog">
            <div class="upload-file-content">
                <el-table :data="goodsScoreList" class="customTable goods-text-table" style="width: 100%; flex: 1;" height="1%"
                          :header-cell-style="{fontWeight: 'normal', height: '40px', color: '#333', background: '#F2F3FA',fontSize: '14px'}"
                          :cell-style="{fontSize: '14px',color: '#333333',height: '40px'}">
                    <el-table-column prop="name" label="评委名称" align="center"></el-table-column>
                    <el-table-column prop="score" label="分数" align="center"></el-table-column>
                    <el-table-column prop="time" label="评分时间" align="center"></el-table-column>
                </el-table>
                <el-pagination class="pager-center" style="margin-top: 20px;text-align: center"
                               :current-page="scorePages.currentPageNum"
                               :page-size="scorePages.eachPageNum"
                               :total="scorePages.total"
                               layout="prev, pager, next, jumper"
                               @current-change="scoreCurrentChange">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "GoodsInfo",
        data() {
            return {
                //商品文字信息撰写
                goodsTextList: [
                    {
                        content: '商品文字信息撰写',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }

                ],
                //商品拍摄与处理
                goodsShootList: [
                    {
                        content: '商品拍摄与处理',
                        score: '8'
                    }
                ],
                //商品视频拍摄与处理
                goodsVideoShootList: [
                    {
                        content: '商品视频拍摄与处理',
                        score: '8'
                    }
                ],
                //商品主图弹窗
                goodsImgDialog: false,
                //评分详情弹窗
                scoreDetailDialog: false,
                //评分列表
                goodsScoreList: [],
                //分页
                scorePages:{
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
            }
        },
        methods: {
            //查看商品主图
            viewGoodsImg(row) {
                this.goodsImgDialog = true;
            },
            //查看大图
            viewBigImg() {

            },
            //下载文件
            downloadFile() {

            },
            //商品拍摄评分详情
            scoreDetailGoods() {
                this.scoreDetailDialog = true;
            },
            //商品视拍摄评分详情
            scoreDetailView() {

            },
            //关闭商品主图弹窗
            handleCloseGoodsImgDialog() {

            },
            //关闭评分详情弹窗
            handleCloseScoreDetailDialog() {

            },
            //分页
            scoreCurrentChange(val) {
                this.scorePages.currentPageNum = val;
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-wrapper {
        height: 100%;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;
        .table {
            height: 100%;
            ::v-deep > .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        .goods-text-table {
            .answer {
                display: flex;
                align-items: center;
                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                    cursor: pointer;
                }
                .text {
                    flex: 1;
                    width: 1%;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
        }
        .link-box {
            .view-detail {
                ::v-deep .el-link--inner {
                    color: #1AB163;
                }
            }
        }
        .goods-img-dialog {
            .upload-file-content {
                display: flex;
                justify-content: space-between;
                width: 100%;
                height: 445px;
                .big-img {
                    width: 444px;
                    height: 444px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .small-img {
                    flex: 1;
                    width: 1%;
                    margin-left: 94px;
                    img {
                        width: 80px;
                        height: 80px;
                        margin-bottom: 15px;
                        border: 2px solid transparent;
                        box-sizing: border-box;
                        &:nth-child(2n-1) {
                            margin-right: 18px;
                        }
                        &:hover {
                            cursor: pointer;
                            border: 2px solid #2DC079;
                        }
                    }
                }
            }
        }
        .goods-score-dialog {
            .upload-file-content {
                display: flex;
                flex-direction: column;
                height: 383px;
            }
        }
    }
</style>